import React from 'react';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => {
    const height = 10;
    const inputTrack = {
        background: "transparent",
        height
    };
    const inputThumb = {
        background: theme.palette.iisightHeader,
        border: 0,
        borderRadius: "50%",
        height,
        width: height,
        marginTop: 0
    };
    const focused = {
        outline: `1px solid ${theme.palette.ui06}`
    };
    return {
        sliderContainer: {
            cursor: "pointer",
            width: "100%",
            position: "relative",
            textAlign: "center"
        },
        knobContainer: {
            display: "flex",
            justifyContent: "space-between",
            margin: `2px !important`,
            position: "absolute",
            width: "calc(100% - 4px)"
        },
        knob: {
            background: theme.palette.iisightWhiteBackground,
            borderRadius: "50%",
            display: "inline-block",
            height: height - 4,
            width: 6
        },
        track: {
            background: theme.palette.iisightDarkBrandBackground,
            borderRadius: height / 2,
            height
        },
        slider: {
            "&.custom-slider": {
                "-webkit-appearance": "none",
                background: "transparent",
                left: 0,
                position: "absolute",
                top: 0,
                width: "100%",
                "&.focus-visible": {
                    outline: "none !important",
                    "&::-webkit-slider-runnable-track": focused,
                    "&::ms-track": focused,
                    "&::-moz-range-track": focused
                },
                "&::-webkit-slider-runnable-track": {
                    "-webkit-appearance": "none",
                    ...inputTrack
                },
                "&::-webkit-slider-thumb": {
                    "-webkit-appearance": "none",
                    position: "relative",
                    ...inputThumb
                },
                "&::ms-track": {
                    ...inputTrack
                },
                "&::-ms-thumb": {
                    ...inputThumb
                },
                "&::-moz-range-track": {
                    ...inputTrack
                },
                "&::-moz-range-thumb": {
                    ...inputThumb
                }
            }
        }
    };
});
/**
 *  Custom slider.
 *
 *  @returns {ReactElement}
 */
function Slider({ ariaLabel, max, min, onChange, step, value }) {
    const { classes, cx } = useStyles();
    const knobs = [...Array(Math.floor((max - min) / step) + 1)];
    return (React.createElement("div", { className: classes.sliderContainer },
        React.createElement("ul", { "aria-hidden": true, className: cx('empty-list', classes.knobContainer) }, knobs.map((_, i) => (React.createElement("li", { className: classes.knob, key: `knob-${i}` })))),
        React.createElement("div", { className: classes.track }),
        React.createElement("input", { "aria-label": ariaLabel, className: cx(classes.slider, 'custom-slider'), max: max, min: min, onChange: onChange, step: step, type: 'range', value: value })));
}
export default Slider;
